export const drinkPresets = [
  { key: 'kopi:default:default:default:none:hot', name: 'Kopi' },
  { key: 'kopi:o:default:default:none:hot', name: 'Kopi O' },
  { key: 'kopi:o:kosong:default:none:hot', name: 'Kopi O Kosong' },
  { key: 'kopi:c:default:default:none:hot', name: 'Kopi C' },
  { key: 'teh:default:default:default:none:hot', name: 'Teh' },
  { key: 'teh:o:default:default:none:hot', name: 'Teh O' },
  { key: 'teh:o:kosong:default:none:hot', name: 'Teh O Kosong' },
  { key: 'teh:c:default:default:none:hot', name: 'Teh C' },
  { key: 'kopi:default:default:default:none:iced', name: 'Kopi Peng' },
  { key: 'teh:default:default:default:none:iced', name: 'Teh Peng' },
  { key: 'cham:::::hot', name: 'Cham' },
  { key: 'milo:::::hot', name: 'Milo' },
  { key: 'milo:::::iced', name: 'Milo Peng' },
  { key: 'barley:::::iced', name: 'Barley' },
  { key: 'bandung:::::iced', name: 'Bandung' },
  { key: 'lemon-tea:::::iced', name: 'Lemon Tea' }
];